import styled from 'styled-components';

import { variable } from '../../helpers/style.helpers';

import { Tab as BaseTab, TabMenuItemProps } from '@aircall/tractor';

export const Tab = {
  ...BaseTab,
  Menu: styled(BaseTab.Menu).attrs(() => ({ space: 'm', variant: 'auto' }))`
    padding-right: ${variable.space.xl}px;
    padding-left: ${variable.space.xl}px;
  `,
  MenuItem: styled(BaseTab.MenuItem)<TabMenuItemProps & { active?: boolean }>`
    height: 100%;
    font-size: ${variable.typography.variants.subheading.fontSize};
  `,
  Item: styled(BaseTab.Item)`
    padding: ${variable.space.xl}px;
  `,
  BaseTabItem: styled(BaseTab.Item)`
    padding: 0;
  `,
};
